import React, {useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom'

import {
    getAvkom,
    getBarnebarn,
    getForfedre,
    getHelSoesken,
    getHund,
    getKullSammeFar,
    getKullSammeMor,
    getSoeskenSammeKull,
    getStamtavleTre
} from "../api";
import Stamtavle from "../components/Stamtavle";


const StamtavleContainer = (props) => {
    const sisteHunder = props.sisteHunder;
    const favoritter = props.favoritter;
    const hund = props.hund;
    const { id } = props.match.params;
    const {kull} = useFetchKull(hund.hundId, id);
    let farHundId = null;
    let morHundId = null;

    if (kull !== null) {
        if (kull.far !== null) farHundId = kull.far.hundId;
        else farHundId = hund.farHundId;

        if (kull.mor !== null) morHundId = kull.mor.hundId;
        else morHundId = hund.morHundId;
    }
    else {
        if (hund.farHundId !== null) farHundId = hund.farHundId;
        if (hund.morHundId !== null) morHundId = hund.morHundId;
    }

    const {forfedre} = useFetchForfedre(hund.hundId, id);

    const {stamtavleTreData, isStamtavleTreLoading} = useFetchStamtavleTre(hund.hundId, morHundId, farHundId, id);
    const {stamtavleTreData8Gen, isStamtavleTreLoading8Gen} = useFetchStamtavleTre8Gen(hund.hundId, morHundId, farHundId, id);

   /*
    const {far} = useFetchFar(farHundId);
    let farfarHundId = null;
    let farmorHundId = null;
    if (far !== null) {
        farfarHundId = far.farHundId;
        farmorHundId = far.morHundId;
    }
    const {farfar} = useFetchFarfar(farfarHundId);
    const {farmor} = useFetchFarmor(farmorHundId);

    const {mor} = useFetchMor(morHundId);
    let morfarHundId = null;
    let mormorHundId = null;
    if (mor !== null) {
        morfarHundId = mor.farHundId;
        mormorHundId = mor.morHundId;
    }

    const {mormor} = useFetchMormor(mormorHundId);
    const {morfar} = useFetchMorfar(morfarHundId);

    */

    const {valper} = useFetchHelSoeskenValper(hund.hundId, id);
    const {kullSammeFar} = useFetchSoeskenSammeFar(hund.hundId, id);
    const {kullSammeMor} = useFetchSoeskenSammeMor(hund.hundId, id);

    const {avkom} = useFetchAvkom(hund.hundId, id);
    const {barnebarn} = useFetchBarnebarn(hund.hundId, id);


    const stamtavleTre = {data: stamtavleTreData, loading: isStamtavleTreLoading,
        data8Gen: stamtavleTreData8Gen, loading8Gen: isStamtavleTreLoading8Gen};

    return (
        <div>
            <Stamtavle hund={hund}
                       kull={kull}
                       helSoeskenValper={valper}
                       kullSammeMor={kullSammeMor}
                       kullSammeFar={kullSammeFar}
                       avkom={avkom}
                       barnebarn={barnebarn}
                       stamtavleTre={stamtavleTre}
                       forfedre={forfedre}
                       sisteHunder={sisteHunder}
                       favoritter={favoritter}
            />
        </div>
    );
}


const useFetchKull = (id, bevisId) => {
    const [kull, setKull] = useState(null);
    const [isKullLoading, setIsKullLoading] = useState(false);
    const [errorKullText, setErrorKullText] = useState(null);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsKullLoading(true);
                setErrorKullText(null);
            }
            getSoeskenSammeKull(id, bevisId)
                .then((kull) => {
                    if (isMounted) {
                        setKull(kull);
                        setIsKullLoading(false);
                    }

                })
                .catch((err)=> {
                    if (isMounted) {
                        console.log(err.message);
                        setIsKullLoading(false);
                        setErrorKullText(err.message);
                    }
                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [id, bevisId]);

    return { kull, isKullLoading, errorKullText };
};


const useFetchHelSoeskenValper = (hundId, id) => {
    const [valper, setValper] = useState([]);
    const [isValperLoading, setIsValperLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsValperLoading(true);
            }
            getHelSoesken(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        let valperArray = [];
                        for (var i = 0; i < data.length; i++) {
                            valperArray.push(data[i]);
                        }
                        setValper(valperArray);
                        setIsValperLoading(false);
                    }

                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsValperLoading(false);
                        setValper(null);
                    }

                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { valper, isValperLoading };
};


const useFetchSoeskenSammeFar = (hundId, id) => {
    const [kullSammeFar, setKullSammeFar] = useState([]);
    const [isKullSammeFarLoading, setIsKullSammeFarLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsKullSammeFarLoading(true);
            }
            getKullSammeFar(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        let kullArray = [];
                        for (var i = 0; i < data.length; i++) {
                            kullArray.push(data[i]);
                        }
                        setKullSammeFar(kullArray);
                        setIsKullSammeFarLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsKullSammeFarLoading(false);
                        setKullSammeFar(null);
                    }

                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { kullSammeFar, isKullSammeFarLoading };
};

const useFetchSoeskenSammeMor = (hundId, id) => {
    const [kullSammeMor, setKullSammeMor] = useState([]);
    const [isKullSammeMorLoading, setIsKullSammeMorLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsKullSammeMorLoading(true);
            }
            getKullSammeMor(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        let kullArray = [];
                        for (var i = 0; i < data.length; i++) {
                            kullArray.push(data[i]);
                        }
                        setKullSammeMor(kullArray);
                        setIsKullSammeMorLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsKullSammeMorLoading(false);
                        setKullSammeMor(null);
                    }

                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { kullSammeMor, isKullSammeMorLoading };
};

const useFetchAvkom = (hundId, id) => {
    const [avkom, setAvkom] = useState([]);
    const [isAvkomLoading, setIsAvkomLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsAvkomLoading(true);
            }
            getAvkom(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        let kullArray = [];
                        for (var i = 0; i < data.length; i++) {
                            kullArray.push(data[i]);
                        }
                        setAvkom(kullArray);
                        setIsAvkomLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsAvkomLoading(false);
                        setAvkom(null);
                    }

                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { avkom, isAvkomLoading };
};


const useFetchBarnebarn = (hundId, id) => {
    const [barnebarn, setBarnebarn] = useState([]);
    const [isBarnebarnLoading, setIsBarnebarnLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsBarnebarnLoading(true);
            }
            getBarnebarn(hundId, id)
                .then((data) => {
                    if (isMounted) {
                        let kullArray = [];
                        for (var i = 0; i < data.length; i++) {
                            kullArray.push(data[i]);
                        }
                        setBarnebarn(kullArray);
                        setIsBarnebarnLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsBarnebarnLoading(false);
                        setBarnebarn(null);
                    }

                });
        };
        fetchData();
        return () => {
            isMounted = false;
        };
    }, [hundId, id]);
    return { barnebarn, isBarnebarnLoading };
};

const useFetchStamtavleTre = (hundId, morHundId, farHundId, bevisId) => {
    if (morHundId === null) morHundId = "";
    if (farHundId === null) farHundId = "";
    const [stamtavleTreData, setStamtavleTreData] = useState(null);
    const [isStamtavleTreLoading, setIsStamtavleTreLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsStamtavleTreLoading(true);
                setStamtavleTreData(null);
            }
            getStamtavleTre(hundId,  3, 4, false, bevisId)
                .then((data) => {
                    if (isMounted) {
                        //console.log(data);
                        setStamtavleTreData(data);
                        setIsStamtavleTreLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsStamtavleTreLoading(false);
                        setStamtavleTreData(null);
                    }

                    console.log(err)
                });
        };
        if (morHundId !== null || farHundId !== null) {
            fetchData();
        }
        else {
            setStamtavleTreData(null);
        }

        return () => {
            isMounted = false;
        };
    }, [hundId, morHundId, farHundId, bevisId]);
    return { stamtavleTreData, isStamtavleTreLoading };
}

const useFetchStamtavleTre8Gen = (hundId, morHundId, farHundId, bevisId) => {
    if (morHundId === null) morHundId = "";
    if (farHundId === null) farHundId = "";
    const [stamtavleTreData8Gen, setStamtavleTreData8Gen] = useState(null);
    const [isStamtavleTreLoading8Gen, setIsStamtavleTreLoading8Gen] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsStamtavleTreLoading8Gen(true);
                setStamtavleTreData8Gen(null);
            }
            getStamtavleTre(hundId,  7, 7, false, bevisId)
                .then((data) => {
                    if (isMounted) {
                        //console.log(data);
                        setStamtavleTreData8Gen(data);
                        setIsStamtavleTreLoading8Gen(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsStamtavleTreLoading8Gen(false);
                        setStamtavleTreData8Gen(null);
                    }

                    console.log(err)
                });
        };
        if (morHundId !== null || farHundId !== null) {
            fetchData();
        }
        else {
            setStamtavleTreData8Gen(null);
        }
        return () => {
            isMounted = false;
        };
    }, [hundId, morHundId, farHundId, bevisId]);
    return { stamtavleTreData8Gen, isStamtavleTreLoading8Gen };
}


const useFetchMor = (id) => {
    const [mor, setMor] = useState(null);
    const [isMorLoading, setIsMorLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsMorLoading(true);
            }
            getHund(id)
                .then((hund) => {
                    if (isMounted) {
                        setMor(hund);
                        setIsMorLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsMorLoading(false);
                        setMor(null);
                    }
                });
        };
        if (id !== null) {
            fetchData();
        } else {
            setMor(null);
        }
        return () => {
            isMounted = false;
        };
    }, [id]);

    return { mor, isMorLoading };
};

const useFetchMormor = (id) => {
    const [mormor, setMormor] = useState(null);
    const [isMormorLoading, setIsMormorLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsMormorLoading(true);
            }
            getHund(id)
                .then((hund) => {
                    if (isMounted) {
                        setMormor(hund);
                        setIsMormorLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsMormorLoading(false);
                        setMormor(null);
                    }
                });
        };
        if (id !== null) {
            fetchData();
        } else {
            setMormor(null);
        }
        return () => {
            isMounted = false;
        };
    }, [id]);

    return { mormor, isMormorLoading };
};

const useFetchMorfar = (id) => {
    const [morfar, setMorfar] = useState(null);
    const [isMorfarLoading, setIsMorfarLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsMorfarLoading(true);
            }
            getHund(id)
                .then((hund) => {
                    if (isMounted) {
                        setMorfar(hund);
                        setIsMorfarLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsMorfarLoading(false);
                        setMorfar(null);
                    }
                });
        };
        if (id !== null) {
            fetchData();
        } else {
            setMorfar(null);
        }
        return () => {
            isMounted = false;
        };
    }, [id]);

    return { morfar, isMorfarLoading };
}

const useFetchForfedre = (hundId, id) => {
    const [forfedre, setForfedre] = useState(null);
    const [isForfedreLoading, setIsForfedreLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsForfedreLoading(true);
            }
            getForfedre(hundId, id)
                .then((forfedre) => {
                    if (isMounted) {
                        setForfedre(forfedre);
                        setIsForfedreLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsForfedreLoading(false);
                        setForfedre(null);
                    }
                });
        };
        if (hundId !== null) {
            fetchData();
        } else {
            setForfedre(null);
        }
        return () => {
            isMounted = false;
        };
    }, [id, hundId]);

    return { forfedre, isForfedreLoading };
};


const useFetchFar = (id) => {
    const [far, setFar] = useState(null);
    const [isFarLoading, setIsFarLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsFarLoading(true);
            }
            getHund(id)
                .then((hund) => {
                    if (isMounted) {
                        setFar(hund);
                        setIsFarLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsFarLoading(false);
                        setFar(null);
                    }
                });
        };
        if (id !== null) {
            fetchData();
        } else {
            setFar(null);
        }
        return () => {
            isMounted = false;
        };
    }, [id]);

    return { far, isFarLoading };
};

const useFetchFarfar = (id) => {
    const [farfar, setFarfar] = useState(null);
    const [isFarfarLoading, setIsFarfarLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsFarfarLoading(true);
            }
            getHund(id)
                .then((hund) => {
                    if (isMounted) {
                        setFarfar(hund);
                        setIsFarfarLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsFarfarLoading(false);
                        setFarfar(null);
                    }
                });
        };
        if (id !== null) {
            fetchData();
        } else {
            setFarfar(null);
        }
        return () => {
            isMounted = false;
        };
    }, [id]);

    return { farfar, isFarfarLoading };
}

const useFetchFarmor = (id) => {
    const [farmor, setFarmor] = useState(null);
    const [isFarmorLoading, setIsFarmorLoading] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const fetchData = () => {
            if (isMounted) {
                setIsFarmorLoading(true);
            }
            getHund(id)
                .then((hund) => {
                    if (isMounted) {
                        setFarmor(hund);
                        setIsFarmorLoading(false);
                    }
                })
                .catch((err)=> {
                    if (isMounted) {
                        setIsFarmorLoading(false);
                        setFarmor(null);
                    }
                });
        };
        if (id !== null) {
            fetchData();
        } else {
            setFarmor(null);
        }
        return () => {
            isMounted = false;
        };
    }, [id]);

    return { farmor, isFarmorLoading };
}

export default withRouter(StamtavleContainer);
